import { Card, CardContent, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import TaskIcon from '@mui/icons-material/Task';
import FeedIcon from '@mui/icons-material/Feed'
import { Link as RouterLink } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';
import PersonIcon from '@mui/icons-material/Person';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GroupsIcon from '@mui/icons-material/Groups';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder'
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';


export const OpcionesMenuNav = ({ opciones }) => {

    let tamIco = 50;

    const iconMapping = {
        HomeRepairServiceIcon: <HomeRepairServiceIcon sx={{ fontSize: tamIco }} />,
        TaskIcon: <TaskIcon sx={{ fontSize: tamIco }} />,
        FeedIcon: <FeedIcon sx={{ fontSize: tamIco }} />,
        ConstructionIcon: <ConstructionIcon sx={{ fontSize: tamIco }} />,
        PersonIcon: <PersonIcon sx={{ fontSize: tamIco }} />,
        AccountTreeIcon: <AccountTreeIcon sx={{ fontSize: tamIco }} />,
        CircleNotificationsIcon: <CircleNotificationsIcon sx={{ fontSize: tamIco }} />,
        AccessAlarmIcon: <AccessAlarmIcon sx={{ fontSize: tamIco }} />,
        TimelapseIcon: <TimelapseIcon sx={{ fontSize: tamIco }} />,
        CreditCardIcon: <CreditCardIcon sx={{ fontSize: tamIco }} />,
        GroupsIcon: <GroupsIcon sx={{ fontSize: tamIco }} />,
        FolderSharedIcon: <FolderSharedIcon sx={{ fontSize: tamIco }} />,
        PlagiarismIcon: <PlagiarismIcon sx={{ fontSize: tamIco }} />,
        QueryBuilderIcon: <QueryBuilderIcon sx={{ fontSize: tamIco }} />,
        FileUploadIcon: <FileUploadIcon sx={{ fontSize: tamIco }} />,
        SyncAltIcon: <SyncAltIcon sx={{ fontSize: tamIco }} />,
        BusinessCenterIcon: <BusinessCenterIcon sx={{ fontSize: tamIco }} />,


    };
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="start"
            size={{ xs: 12 }}
            spacing={3}
        >
            {opciones.map(opcion => (
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }}
                    key={opcion.id}
                    gap={2}
                    className="menu-card"
                    component={RouterLink}
                    to={opcion.url}
                    sx={{ textDecoration: "none", color: "inherit" }}
                >
                    <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                        <IconButton size={'large'} color="primary">
                            {iconMapping[opcion.icon]}
                        </IconButton>
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="end"
                        alignItems={{ xs: "start", sm: "end" }}
                        size={{ xs: 12, sm: 9, md: 9, lg: 9 }}
                    >
                        <Typography variant="h5">
                            {opcion.nombre.toUpperCase()}
                        </Typography>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    )
}
